import base2 from './base2.repository';
import { axios } from './axios';
import { _url } from '../utils/http.util';

export default {
    getDocuments: (params) => base2.get('clients/contractor-management/documents', params),
    getContractorDocuments: (contractorId) => base2.get(`clients/contractor-management/contractors/${contractorId}/documents`),
    approveDocument: (id) => base2.post(`clients/contractor-management/documents/${id}/approve`, {}),
    rejectDocument: (id, payload) => base2.post(`clients/contractor-management/documents/${id}/reject`, payload),
    downloadDocument: (id) => axios.get(_url(`clients/contractor-management/documents/${id}/download`), { responseType: 'blob' }),
};
